export default "__VITE_ASSET__c2c03b21__"